import React, {Fragment, useState} from 'react';
import { Popover, Transition } from '@headlessui/react';
import {NavLink} from 'react-router-dom';
import {signOut} from 'firebase/auth';
import {auth} from '../config/firebaseConfig';
import { UserAuth } from '../App';

import {
    ChevronDoubleDownIcon,
    XMarkIcon,
    ArrowLeftOnRectangleIcon
  } from '@heroicons/react/24/outline';

function NavbarAdminHome() {

    const {user} = UserAuth();

    async function logOut() {
        signOut(auth);
        console.log("Cierro Sesión");
    }

    const [fix, setFix] = useState(false);

    function setFixed() {
      if (window.scrollY >= 10){
        setFix(true);
      } else {
        setFix(false);
      }
    }


  
    window.addEventListener("scroll", setFixed) 
    return(
        <div className="relative z-50">
            <Popover className={fix ? "fixed w-full bg-white my-0 drop-shadow-shad" : "fixed w-full bg-white my-0"}>
            <div className="mx-auto px-4 sm:px-8">
                <div className="flex items-center justify-between py-3 md:justify-start md:space-x-10">
                <div className="flex justify-start lg:w-0 lg:flex-1">
                    <NavLink to="/">
                    <span className="sr-only">Laboratorio Santa Bárbara</span>
                    <img
                        className="h-8 w-auto sm:h-10 scale-125 md:scale-150"
                        src="logo.png"
                        alt=""
                    />
                    </NavLink>
                </div>
                {user.role === 'admin' ? <Popover.Group as="nav" className="flex flex-row space-x-10">
                    <NavLink to="/ManageAdmins" className="hidden text-base font-medium text-navFont-100 hover:text-primary-100 md:flex">
                        ADMINISTRADORES
                    </NavLink>

                    <NavLink to="/AboutUsAdmin" className="hidden text-base font-medium text-navFont-100 hover:text-primary-100 md:flex">
                        NOSOTROS
                    </NavLink>

                    <NavLink to="#" className="hidden text-base font-medium text-navFont-100 hover:text-primary-100 md:flex">
                        CLIENTES
                    </NavLink>
                </Popover.Group> : null }
                

                <div className="-my-2 -mr-2 items-center justify-end md:flex md:flex-1 lg:w-0">
                    <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-primary-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-100">
                    <span className="sr-only">Open menu</span>
                    <ChevronDoubleDownIcon className="h-6 w-6" aria-hidden="true" />
                    </Popover.Button>
                </div>
                </div>
            </div>

            <Transition
                as={Fragment}
                enter="duration-200 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-100 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <Popover.Panel focus className="absolute w-96 right-0 top-0 transform p-2 transition z-20">
                <div className="divide-y-2 divide-gray-50 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                    <div className="px-5 pt-5 pb-6">
                    <div className="flex items-center justify-between">
                        <div className="-mr-2 absolute right-7">
                        <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-primary-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-100">
                            <span className="sr-only">Close menu</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </Popover.Button>
                        </div>
                    </div>
                    </div>

                    <div className="space-y-6 py-6 px-5">
                    <div className="grid grid-cols-1 gap-y-4 gap-x-8 text-center">
                        <button onClick={logOut} className="flex flex-row text-base justify-center font-bold text-navFont-100 hover:text-primary-100">
                        <ArrowLeftOnRectangleIcon className='h-6 w-6 mr-2' aria-hidden='true'/>
                        CERRAR SESIÓN
                        </button>
                    </div>
                    </div>
                </div>
                </Popover.Panel>
            </Transition>
            </Popover>
        </div>
    )
}

export default NavbarAdminHome;